
export class CarrierRequirementExemptionDialogParams{
    public carrierMasterApprovalRequirementId?: string;
    public carrierName: string;
    public carrierId: string;

}